export default __webpack_public_path__ + "static/media/19.5c5cff22.png";